import { render, staticRenderFns } from "./Registro3.vue?vue&type=template&id=4ab2922c&scoped=true&"
import script from "./Registro3.vue?vue&type=script&lang=js&"
export * from "./Registro3.vue?vue&type=script&lang=js&"
import style0 from "./Registro3.vue?vue&type=style&index=0&id=4ab2922c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab2922c",
  null
  
)

export default component.exports